/**
 * AUTOGENERATED from the public Language slugs represented by Web's admin
 * Language.bcp47 snapshot, plus public Watch URL overrides.
 *
 * Regenerate via: pnpm --filter @forge/web generate:language-bcp47-map
 * Drift check:    pnpm --filter @forge/web check:language-bcp47-map
 *
 * Keep this compact slug-only corpus in the dependency-free URL package so
 * every Forge client can make the same language-home collision decision
 * without bundling the full slug-to-BCP-47 value map.
 *
 * This corpus is a synchronous fallback, not the route authority: Web's
 * proxy and page also admit any audio slug the live Watch route manifest
 * lists (apps/web/src/lib/watch-route-manifest.ts).
 *
 * Alignment with the BCP-47 map is checked by
 * apps/web/src/lib/locale.test.ts.
 */
const PUBLIC_WATCH_LANGUAGE_SLUG_CORPUS = `a-hmao
aari
abanglekuo
abanyom
abau
abidji
abkhaz
abure
abureni
acateco
acchami
aceh
achang
ache
ache-2
achi-rabinal
acholi
achuar-shiwiar
adangme
adele
adi
adioukrou
adonara
adygey
adzera
afar
afrikaans
agabag
agarabi
agatu
aghem
aguna
agusan-surigao-manobo
ahanta
ahirani
aikana
aja-gbe
ajiya
akebu
akeu
akha
aklanon
akoose
akposo
akuku
alaba
alagwa
alangan
albanian
albanian-kosovar
ale-gawwada
alis-i-ron
altai
alur
ama
amam
amanab
ambae-east
ambai
ambrym-southeast
amdo-tibetan
american-sign-language
amharic
amuzgo-guerrero
amuzgo-oaxaca
anaang
andaandi
andio
angaataha
angal-heneng
angika
anjam
ansus
antandroy
antesaka
anuak
anufo
anyin
ao
aokha
apalai
apinaye
apurina
arabic-algerian-spoken
arabic-bedouin
arabic-chadian-spoken
arabic-egyptian-colloquial
arabic-gulf
arabic-hassaniya
arabic-hijazi
arabic-iraqi-baghdadi
arabic-juba
arabic-khuzestani
arabic-libyan
arabic-modern-standard
arabic-modern-standard-egyptian
arabic-modern-standard-sharif
arabic-moroccan-spoken
arabic-najdi
arabic-north-african
arabic-palestinian
arabic-saidi-spoken
arabic-sanaani
arabic-sudanese-spoken
arabic-taizzi-yemeni
arabic-tunisian
aralle
aramba
arbore
are
arhe
arifama-miniafia
aringa
armenian
armenian-western
arosi
arumanian
asante-twi
ashaninka
asheninca-pichis
assamese
assamese-muslim
assyrian
ateso
athpariya
atitlan-mixe
auhelawa
aukaans
avar
avikam
avokaya
awa
awa-8
awa-cuaiquer
awad-bing
awadhi
awadhi-nepal
awajun
awak
awgni
awing
awutu
ayizo-2
ayizo-tori
aymara-central
ayoreo
ayta-abellen
ayta-ambala
ayta-mag-antsi
ayta-mag-indi
azerbaijani-iran
azerbaijani-north
azha
aztec-nahuatl-guerrero
babanki
bacama-bwatiye
bada
badaga
bade
bado-parja
baeggu
baelelea
bafut
bagheli
bagri
bahasa-melayu-2
bahnar
bai
bai-lama
bai-southern
baiso
baitadeli
bajau-indonesian
bajhangi
bajureli
baka
bakairi
bakhtiari
bakumpai
bakwe
balangao
balangin-indo
balanta
balanta-ganja
balanta-naga
balantak
bali
bali-madya
balkar
balochi-eastern
balochi-southern
balochi-western
balti
bambam
bambara
bamu
bamun
bana
banda-linda
bandi
bandial
banggai
bangi
bangjinge
bangka
bangla-2
bangla-muslim
banjar
bankagooma
bantoanon
bara
bara-tharu
barai
bareli-pawri
bareli-rathwi
bari
bariai
bariba
barka
basa
basaa
basang
bashkir
basketto
basque
bassa
batak-alas
batak-angkola
batak-karo
batak-kluet
batak-mandailing
batak-simalungun
batak-toba
bateq
batui
baule
bauria
bawean
bazigar
bedamuni
beembe
behoa
beja-bidhaawyeet
bekwarra
bekwel
bel
belanda-viri
belleh
belorussian
bemba
bembe
bena
benabena
bench
bende-tongwe
bengali-indian
benyadu
berom
betawi
bete-daloa
bete-gagnoa
bete-guiberoua
bette
bhadrawahi
bharia
bhatri
bhattiyali
bhele
bhilali
bhili
bhogoto
bhojpuri
bhojpuri-nepal
biafada
biak
bicolano
bidayuh-jagoi
bijago
bikol-buhinon
bilaspuri
bilua
bima
bimin
bimoba
binandere
bine
binukid
birifor
birifor-southern
bishnupriya
bislama
bisu
blaan-koronadal
blaan-sarangani
blackfoot
blang
blin
blowo
bobe
bobo-madare-southern
bodo
bogghom
bokyi
bola
bolewa
bolinao
bomu
bongo
bora
borna-shinasha
bororo
bosnian
bouyei
bouyei-anshun
bouyei-qianxi
bozo-jenaama
bozo-tigemaxo
brahui
braj-bhasha
brazilian-sign-language
brezhoneg
bru-eastern
bru-van-kieu
budu-koya
budu-nita
budza
bugis
bugis-soppeng
bugkalot
buglere
bukharian
buksa
bukusu
bulgarian
buli
bulu
bulusu
bum
bundel-khandi
bungu
buol
bura-pabir
buriat-russia
burmese
burmese-common
burmese-musselmani
burmese-standard
burun
burunge
burushaski
buurak
bwamu-laa-laa
bwazza
cabecar
cakchiquel-central
cakchiquel-eastern
cakchiquel-south-central
cakchiquel-western
canela
cantonese
capanahua
carib-eastern
catalan-valencian-balear
cebuano
central-asian-russian
central-buang
cerma
chachi
chakfem
chakma
chaldean
cham-eastern
cham-western
chamacoco
chamari
chamba-daka
chambeali
chamling
chamorro
chara
chasu-pare
chatgaya-chittagonian-hindu
chatgaya-chittagonian-muslim
chatino-nopala
chatino-zenzontepec
chavacano
chechen
cheke-holo
cherepon
chhattisgarhi
chibi-setentrional
chichewa
chikunda
chilcotin
chin-asho
chin-falam
chin-khumi
chin-mun
chin-paite
chinantec-usila
chinanteco-quiotepec
chinanteco-tepetotutla
chinanteco-tlacoatzintepec
chinese-guiliu
chinese-hokkien-amoy
chinese-qinghai
chinese-sichuan
chinese-simplified
chinese-traditional
chinese-yunnan-kunming
chingoni
chitembo
chitwan-tharu
chodri
chokwe-angola
chokwe-congo
chol-tumbala
chonyi
chopi
chumburung
churahi
chuukese
chuvash
chwabo
cia-cia
cirebon
cishingini
clela
cofan
cogui
col
colombian-sign-language
comorian-shingazidja
cook-islands-maori
cora
costa-rican-sign-language
cree-western
crimean-tatar
crioulo-upper-guinea
croatian
csango
cubeo
cuicateco-tepeuxila
cun
curripaco
cuyonon
czech
daani
daasanach
daba
dadeldhureli
dadiya
dagaari-northern
dagaari-southern
dagara
dagbanli
dan
dangali-tharu
dangi
dani-western
danish
dano
darchuleli
dargin
dari
dari-4
datooga
daur
davik-kui
dawro
dayak-ngaju
daza
deccani
deg
dei
dendi-djougou
dendi-malanville
dene
deori
dera
dersim-zazaki
desia
dhatki
dhimal
dhivehi
dhodia
dhopadhola
dhundari
dibali
dida-yocoboue
didinga
digaro-mishmi
digo
dijim-cham
dimasa
dime
dinka-agar-bor
dinka-northeastern-padang
dinka-rek
dirasha
ditammari
djola-bayote
dogon-jamsay
dogon-mombo
dogon-togo-kan
dogon-tommo-so
dogon-tomo-kan
dogon-toro-so
dogose
dogri
dolpo
dom
dong-northern
dong-southern
dongissa
dongnu
dongo
dongxiang
doondo
doromu-koki
doti-doteli
duala
dubli
dulangan-manobo
duna
dungan
dungra-bhil
duri
duruma
duruwa
dusun
dutch
duya
dzongkha
eastern-garame
eastern-poqomchi
ebira
ebrie
eda
ede-cabe
ede-ica
edo
efik
eggon
ehugbo
ejagham-western
ekajuk
ekpari
ellomwe
embera-catio
embera-northern
embu
ende
enga
enggano
english
english-african
english-british
english-north-american-indigenous
enlhet-2
enrekang
enuani
enwan
enxet
erei
erzya
ese
ese-ejja
eshira-2
estonian
etsako-iyekhe
etulo
ewage-notu
ewe
ewondo
ezaa
fa-dambu
fakai
fali-north
fali-south
fanakalo
fanamaket
fang-equatorial-guinea
fang-gabon
fante
faroese
farsi-western
fataleka
fernando-po-creole-english
fiji-hindi
fijian
finallig
finnish
flemish
folopa
fon-gbe
foochow
fordata
fore
french
french-african
fulacunda
fulfulde-adamawa
fulfulde-bagirmi
fulfulde-benin-togo
fulfulde-caka-nigeria
fulfulde-jelgoore
fulfulde-maasina
fulfulde-pulaar
fulfulde-western-niger
fur
furu
fuuta-jalon
fwe
ga
gaanda
gadaba-mudhili
gaddang
gaddi
gadsup
gaelic-irish
gaelic-scots
gagauz
gagu
gaita-koitor
galela
galician
galo
gamai
gamit
gamo
gangam
gao
garasia-adiwasi
garasia-rajput
garhwali
garifuna
garo
gata
gaviao-do-jiparana
gavva
gawri
gayil
gayo
gbagyi
gbanu
gbari
gbaya-kresh-south-sudan
gbaya-northwest
gbaya-southwest
gbe-saxwe
gbe-tofin
gbe-weme
gbeya
gbii
ge
gedeo
gela
gen-gbe
georgian
gepo
german-pennsylvania
german-standard
ghari
ghomala
ghotuo
giangan
gibaio
gichuka
gidar
gikyode
gilaki
gilaki-rashti
giryama
gisir
gitonga
giziga-south
glavda
goan-konkani
godie
gofa
gogo
goji
gojri
gokana
gola
golin
gondi-aheri
gondi-northern
gonja
gorontalo
gourmanchema
gowlan
gowli
grebo-northern
greek
guahibo
guajajara
guambiano
guarani-bolivian-eastern
guarani-mbya
guarani-paraguayan
guarani-western-bolivian
guaymi
guere-central
guhu-samane
guina-ang-kalinga
gujarati
guji
gun-gbe
gungu
gurage-sodo
gurage-west
gurenne
gurgula
guro
gurung
gusii
gutob-gadaba
guyanese-creole
gwere
gyaazi
hadiyya
hadothi
hadza
hainanese
haitian-creole
hajong
hakhun
hakka
halang
halbi
halia
hamer-banna
hamgyongdo
hanga
hani-haya
haniq-beeqhongq
hano
hanunoo
harari
haryanvi
hatam
hausa
havu
hawaii-pidgin
hawaiian-nihau
haya
hazaragi
hdi
hebrew
hehe
heiban
heiyi-zhuang-minz
hema
hemba
herero
higgi
hiligaynon
hindi
hindi-caribbean
hindko-northern
hindko-southern
hiri-motu
hixkaryana
hlai-has
hmar
hmong-daw
hmong-shuad
ho
hona
horned-miao
hote
hrangkhol
hre
huasteco-san-luis-potosi
huasteco-veracruz
huave-san-mateo-del-mar
huba
hui
huichol
huitoto-murui
huli
hunde
hungana
hungarian
hunsrik
hyam
ibaas-icen
ibaloi
iban
ibanag
ibibio
icelandic
ichen
icheve
idaasha
idioma-wanca
idoma
ife
ifugao-amganad
ifugao-mayoyao
igala
igbo
igede
igiha
ika
ikhin
ikizu
ikoma
ikota
ikpeshi
ikwo
ila
ilchamus
ile-ape
ilocano
imbongu
indonesian-isa
indonesian-yesus
ingush
inner-mongolian
innu
inonhan
inor
inuktitut-eastern-canadian
ipili
ipunu
iranun
iranun-eastern
iranun-western
iraqw
iraya
irula
isan
isangu
ishinyiha
isnag
isoko
italian
itawis
iten
itsekiri
ivatan
ixil-nebaj
iyaa
iyansi
izere
izii
jacalteco-western
jadgali
jakun
jama-mapun
jamaican-patwa
jaminawa
japanese
japanese-sign-language
jar
jaruara
jaunsari
javanese
javanese-banten
javanese-banyumasan
javanese-caribbean
jeh
jenjo
jere
jiamao
jibu
jingpho
jita
jju
jola-felupe
jola-fogny
jola-kasa
jorai
jordanian-sign-language
juang
jukun
jula
juni-kuin
jur-beli
jur-modo
juray
kaakye
kaba
kaba-naa-sara
kabardian
kabeverdiane-barlavente
kabiye
kabuverdianu-sotaventu
kabwa
kabyle
kachchhi
kachhi-gujerati
kadiweu
kaduo
kafa
kagulu
kaili-daa
kaiwa
kakataibo
kako
kakwa
kalaallisut-greenlandic
kalabari
kalagan-eastern
kalagan-tagakaulu
kalagen-western
kalanga
kalanguya
kalenjin-kipsigis
kalmyk-oirat
kalo-5
kamano
kamasau
kamayo
kambaata
kambera
kamo
kamuku
kanauji
kandas
kandawo
kandoozi
kanembu
kangri
kanjari
kankanaey
kankanay-northern
kannada
kanuri-yerwa
kanyok
kaonde
kapampangan
karai-karai
karakalpak
karang
karanga
karbi
karelian
karen-pwo
karen-pwo-eastern
karen-pwo-omkoi
karen-sgaw
karina
karnali
karo
karon
karunsie
kasem-burkina-faso
kasem-ghana
kashmiri
kashubian
katab
katang
katcha-kadugli-miri
kathiyawadi
katu-eastern
kau-bru
kaur
kayabi
kayah-li-western
kayan
kayapo
kazakh
keakalo
keapara
kechwa-san-martin
kedang
kekchi
kele
keliko
kendayan-kanayatn
kenyah
kenyah-badeng
kerewe
kerinci
kermanshahi
ketengban
khakas
khampa-eastern
khandeshi-bhili
khandesi
kharia
khasi
khiamniungan
khmer-central-m
khmer-northern
khmer-standard
khmu
khoekhoegowab
khowar
khwarazm
kiche-cunen
kifuliiru
kikamba
kikongo
kikuro
kikuyu
kilaangi
kilega
kiluba
kim
kimbundu
kimeru
kimpokomu
kinandi
kinaray-a
kinga
kinnauri
kinnauri-pahari
kintandu
kinyakyusa-tanzania
kinyamulenge
kinyarwanda
kirho
kiribati
kirundi
kisan
kisanga
kisi
kisi-southern
kissi-northern
kituba
kiviila
kiwilwana
kiyombe
koalib
kobo
kohistani-indus
kohli-parkari
koho
koita-ga
kok-borok
kok-borok-bangladesh
kokoda-k-ainake
kokola
kolami
koli-wadiyara
kolokuma-izon
kom
komering
komi-permyak
komi-zyrian
konda-dora
kongo-san-salvador
konjo-highland
konkomba
konni
kono-sierra-leone
konongo-2
konso
konta
koorete
kope
koraku
korean
korean-north
korean-sign-language
koreguaje
korku
koromfe
kortha
korwa
koti
kouya
koya
kpelle-guinea
kpelle-liberia
kreol-mauricean
krio
krongo
kroumen-plapo
kroumen-pye
kroumen-tepo
kru
kuanua
kui
kukele
kuki
kukna
kulango-bondoukou
kulango-bouna
kulung
kulvi
kumam
kuman
kumauni
kumyk
kuna
kunama
kuni-boazi
kunimaipa
kuo
kupia
kupsapiiny
kuranko
kurdi-behdini
kurdi-hawrami
kurdi-sorani
kurdi-sorani-eastern
kurdish-afrini
kuria
kurmanji-cis
kurmanji-standard
kurumba-jennu
kurumba-kannada
kurux
kusaal
kusaal-eastern
kusaal-western
kuteb
kutia
kutu
kuvale
kuvi
kuvi-odisha
kuy
kwaio
kwamashi
kwamba
kwangali
kwangwa
kwanyama
kwaraae
kwasio
kwatay
kwaya
kwere
kwese
kyrgyz
laadi
laarim
label
ladakhi
lahu
lak
lala
lalo-central
lama
lamaholot
lamalera
lamatuka
lamba
lambadi
lambya
lamnso
lampung-api
lampung-nyo
langilan-manobo
lango-south-sudan
lango-uganda
lao
laro
lashi
latvian
lawangan
lebanese-sign-language
lebanese-syrian-arabic
ledo-ija
ledo-taa
legbo
lelemi
lendu
lenje
lepcha
lepki
lesser-antillean-creole-french
letuama-tanimuca
levantine-turkmen
levuka
lewo
lewo-eleng
lezgi
lhao-vo
lhasa-tibetan
li-bendi
li-qi
lihir
lik
lika
likoonl
limba-tonko-sella
limba-west-central
limbu
limbum
lingala
lingao
lio
lipo-eastern
lipovan
lis-ma-ron
lisu
lithuanian
lobala
lobi
logo
lokaa
loko
lokpa
lolo
loloda
loma
lomwe
longuda
lopit
lorung-northern
lote
lower-daga
lozi
lubu
lubwisi
luchazi
luganda
lugbara
lughuru
lukabaras
lukpa
lumasaba
lumun
lunda
lundayeh
lungga
luo
luragoli
luri-luristan-province-iran
lusoga
lutos
luvale
luwo
luwu-tae
lyele
maanyan
maasai
maay
macedonian
mada
madi
madi-okollo
madura
mafa
magahi
magar-eastern
magar-western
magindanaon
mahasu-pahari
mai-brat
mailu
maithili
maithili-nepal
maiwa
majang
majhi
makaa
makasar
makhau-tanzania
makhuwa
makoma
makonde-mozambique
makonde-tanzania
mal-paharia
malagasy
malagasy-antankarana
malagasy-antesaka
malagasy-northern-betsimisaraka
malagasy-southern-betsimisaraka
malagasy-tanosy
malango-teha
malay
malay-ambonese
malay-bukit
malay-jambi
malay-kota-bangun-kutai
malay-north-moluccan
malay-papuan
malay-pattani
malay-tenggarong-kutai
malayalam
malayic-dayak
male
malila
malinke-kenieba
malinke-kita
malkangiri-koya
malo
maltese
malvi
mam-central
mam-northern
mam-tajumulco
mamainde
mamasa
mambilla
mambwe-lungu
mampruli
mamuju
mamusi
manado
manambu
manda
mandar
mandara
mandara-cameroon
mandarin-china
mandarin-taiwan
mandeali
mandinka
mandja
manga
mangalorean-konkani
mangbetu
manggarai
mangghuer-wuge
mango
maninka
maninka-konyanka
manjaku
mankanya
mano
manobo-ata
manobo-dibabawon
manobo-ilianen
manobo-matigsalug
manobo-sarangani
manobo-tagabawa
manobo-western-bukidnon
mansoanka
manyika
maonan
maori
mapudungun
maquiritari
marakwet
maram-naga
maranao
marathi
marba
mardini
marghi-central
margi-south
mari-low
maria
maria-dandami
markweeta
marma
maro
marshallese
marwari
marwari-northern
marwari-southern
masalit
masana
masbatenyo
mashami-chagga
mashi
masikoro
maskelynes
matal
matengo
mato
matses
matsigenka
matumbi
mawae
mawchi
maxakali
mayan
mayangna
mayogo
mazagway-hidi
mazahua
mazanderani
mazateco-huautla-de-jimenez
mba
mbala
mbandja
mbe
mbelime
mbembe-cross-river
mbembe-tigon
mbosi
mbugwe
mbuko
mbukushu
mbula
medlpa
medumba
meen
meitei
mekeo
mele-fila
melpa
mende
mentawai
mephaa
mephaa-de-acatapec
mephaa-de-huitzapula
meqa
merey
merwari
mewari
mexican-sign-language
meyah
mgbolizhia
miao-central-mashan
miao-chuanqiandian-cluster
miao-eastern-qiandong
miao-huishui-northern
miao-northern-qiandong
miao-small-flowery
miao-southern-qiandong
migili
miju-mishmi
minangkabau
mingrelian
minianka
mirgan
mising
miskito
mixe-coatlan
mixe-del-istmo
mixtec-amoltepec
mixtec-ayutla
mixtec-magdalena-penasco
mixteco-alacatlatzala
mixteco-central-juxtlahuaca
mixteco-cuquila-ocotepec
mixteco-diuxi-tilantongo
mixteco-eastern
mixteco-metlatonoc
mixteco-monte-verde
mixteco-northwest-oaxaca
mixteco-potoichan
mixteco-santa-maria-apasco
mixteco-silacayoapan
mixteco-southern-puebla
mixteco-terroro-venado
miya
mizo-lushai
mmen
mnong-central
mnong-rlam
moba
mochi
modole
mofu-gudur
moken
moksha
molbog
moma
mon
mongo-nkundu
mongolian-halh
mongondow
mono
moore
moro
moru
mosiye
mouwase
mpoto
mpyemo
mro
mru
mualang
mumuye
muna
munda
mundang
mundani
mundari
mundari-south-sudan
mundu
munduruku
mungaka
munukutuba
muong
mupun
muria-eastern
muria-western
murle
musgu
muyang
mwaghavul
mwan
mwani
mwera
mwimbi-igoji-muthambi
naasioi
nafaanra
naga-angami
naga-chang
naga-chokri
naga-khezha
naga-konyak
naga-liangmai
naga-lotha
naga-mao
naga-rongmei
naga-sangtam
naga-sumi
naga-tangkhul
naga-yimchungru
naga-zeme
nagamese
nage
nago
nahuatl-central-huasteca
nahuatl-eastern-huasteca
nahuatl-isthmus-pajapan
nahuatl-michoacan
nahuatl-northern-puebla
nahuatl-orizaba
nahuatl-sierra-de-puebla
nahuatl-southeast-puebla
nahuatl-western-huasteca
nahuatl-zacatlan-ahuacatlan-tepetzintla
nakanai
nalca
nama
nambikuara-southern
nambya
namiae
namwanga
nandeva
nandi
nangjere
napu
nasu-eastern
nauruan
navaho
nawary
nawdm
naxi
ndali
ndamba
ndau
ndebele-northern
ndebele-southern
ndendeule
ndogo
ndokwa-ukwuani
ndola
ndrulo
ndruna
ndut
nembe
nepali
nethakani
new-zealand-sign-language
newari
ngada
ngakarimojong
ngambay
ngamo
ngas
ngbaka
ngbandi
ngbandi-ngiri
ngbugu
nghlawa
ngiemboon
ngindo
ngizim
ngomba
ngombale
ngombe
ngombe-north
ngombe-south
ngonde
ngulu
nguna
ngungwel
nias
nigerian-pidgin-english
nimadi
ninzo
nisu-northern
nivacle
njebi
nkim-nkum
nkoya
nogai
noiri
nomane
noon
noone
north-gumuz
norwegian-bokmal
nosu-shengzha
nosu-tianba
nosu-yinuo
notsi
nsenga
nta
ntcham
nuer
numanggang
nung
nuni-southern
nupe
nusa-penida
nyala
nyamboa
nyamwezi
nyaneka
nyanga
nyangatom
nyaturu
nyiramba
nyishi
nyole
nyungwe
nzakara
nzanyi
nzema
oadki
obamba
obe-nrung-ene
obo-manobo
obolo
od-rajput
odiya
ogan
ogea
ogoni
ojibwa-western
okiek
okinawan-central
okpe
okpella
okrika
oku
olukwumi
olulumo-ikom
olunyole
olutachoni
omi
omwunra-toqura
oniyan
ono
orang-seletar
oriya-adivasi
oro-wari-2
orokaiva
oroko
oromo-borana-arsi-guji
oromo-eastern
oromo-west-central
osetin
osing
ososo
ot-danum
otetela
otomi-eastern
otomi-mezquital
otomi-western
otoro
otuho-lotuko
owa
oyda
paama
padoe
paez
pagabete
pagoe
pak-pak-dairi
palamua
palauan
palaung-pale
palaung-rumai
palembang
palikur
pame-central
pamona
panare
panchpargania
pangasinan
pangwa
pangwali
paniya
panjabi-western
pao
papel
papiamentu
parakana
paranan
pardhan
pardhi
parecis
pasaale
pasemah
pashto-eastern-afghan
pashto-southern
pashto-yusufzai
pattae
pattapu
penang-hokkien
pengo
persian-sign-language
peve
phende
phom
piapoco
piaroa
pidgin-cameroon
pidgin-liberian
pijin
pimbwe
pinyin
pipero
plang
plautdietsch
pnar
pogoro
pohnpeian
poke
pokomo-lower
pokoot
polish
pomeranian-brazilian
pontianak-hakka
popoloca-san-felipe-otlaltepec
popoloca-san-juan-atzingo
popoloca-san-luis-temalacayuca
popoluca-sierra
portuguese-brazil
portuguese-mozambique
portuguese-portugal
pougouli
poumai-naga
powari
provencal
psikye
puinave
pulangiyen
punan-tubu
punjabi
purepecha
purepecha-western-highland
pyam
qanjobal
qashqai
qena
qiang-southern
quechua-ambo-pasco
quechua-ancash-conchucos-northern
quechua-ancash-conchucos-southern
quechua-ancash-huaylas
quechua-ayacucho
quechua-cuzco
quechua-eastern-apurimac
quechua-huanuco-huallaga
quechua-huanuco-huamalies-northern-dos-de-mayo
quechua-lambayeque
quechua-margos-yarowilca-lauricocha
quechua-north-bolivian
quechua-north-junin
quechua-panao-huanuco
quechua-south-bolivian
quechua-southern-pastaza
quiche-central
quiche-joyabaj
quiche-west-central
quichua-canar-highland
quichua-highland-chimborazo
quichua-imbabura-highland
quichua-pastaza
quichua-salasaca-highland
quichua-tena-lowland
rabha
rade
rai-bantawa
rajbangsi-india
rajbanshi-nepal
rakhine
ralte
rampi
rana-tharu
rangpuria-bangla
rao
rathawi
ravula
rawa
rawang
rejang
rendille
reshe
reunion-creole-french
ribeirinho
rigwe
rikbaktsa
rinconada-bikol
roglai-northern
rohingya
romani-balkan
romani-balkan-romania
romani-caldarasi
romani-carpathian
romani-kalderash-western
romani-sinte
romanian
romanian-sign-language
romblomanon
ronga
roviana
rufumbira
rukuba
rumu
runyankole
runyoro
ruruuli-runyala
russian
russian-sign-language
ruund
ruwila
saa
saafi-saafi
sabaot
sabu
sadani
sadri-oraon
safwa
saho-eritrea
sahu
sakalava-analalava
sakalava-besalampy
sakata
salar
saluan
sama-bangingi
sama-central
sama-mum
sama-southern
samarkand-tajik
sambal
sambalpuri
samburu
samia
samo
samoan
san-andres-islander-creole
san-chi
sanga
sanggau
sangihe
sangil
sango
sangu
sani-3
sansi
santali-india
santhali-nepal
sanuma
sapo
saptari
sara
saraiki
saraiki-megwhal
saramaccan
sardinian-logudorese
sarlahi-tharu
sasak
satere-mawe
saura-2
saurashtra
sauria-paharia
saya
sedoa
sehwi
seko-padang
selaru
selayar
semelai
sena
sena-malawi
sengele
sengwer
senoufo-cebaara
senoufo-djimini
senoufo-nyarafolo
senoufo-supyire
senoufo-tagbana
serawai
serbian
serere-sine
seselwa-creole
shambala
shan
shanghainese
shanjo
sharchogpa
shawi-chayahuita
shekhawati
shekkacho
sheko
sherbro
sherpa
shilluk
shimaore
shina
shina-kohistani
shipibo-conibo
shona
shuar
shughni
shui
siang
siar-lak
sidaama
sidamo
siddi
sihanaka-2
sika
sikkiligar
silte
sinasina
sinaugoro
sindhi
sindhi-bhil
sindhi-sansi
sinhala
sirmauri
sisaala-tumulung
sissala
siswati
slavey
slovak
slovenian
soli
somali
somba-siawari
songai-timbuktu
songe
songhay-gao
soninke
sora
sotho-northern
sotho-southern
sougb
south-gumuz
southern-gondi-adilabad
southern-nisu
spanish-castilian
spanish-latin-american
sranan-tongo
suau
suba
suba-simbiti
subanen-eastern
subanen-northern
subanon-western
suena
suku
sukuma
sukur
sula
sumbawa
sunda
sunda-alus
sundanese-banten
sunuwar
suodi
surgujia
suri-tirmaga-chai
surjapuri
surui
suryoyo
susu
swahili-congo
swahili-kenya
swahili-tanzania
swedish
sylheti
sylhetti
syriac
taa
tabaru
tabassaran
tacawit
tachelhit
tado
tagalog
tagbanwa-calamian
tahitian
tai-dam
tai-don
tai-lue
tai-nua
tairora
taita
tajik
tajpuriya
takia
takuu-nakumanu
takwane
tal
talaandig-manobo
talaud
tali-2
talysh
tamajeq-tahoua
tamang-eastern
tamang-western
tamasheq-kidal
tamazight-central-atlas
tambee
tamil
tampulma
tangale
tangoa
tangsa-kimsing
tangshang-shecyu-cyamcyang
tanjijili
tanna-north
tanna-southwest
tarahumara-baja
tarahumara-central
tarifit
tarifit-arabic-based-script
tarifit-latin-based-script
tarok
tasahlit
tat-azeri
tat-juhuri
tatar
tausug
taveta
tawala
tawbuid-eastern
tboli
tchien-krahn
tchumbuli
tehit
tehl
teke-central
teke-eboo
teke-tege
telugu
tem
tembarissa
temi
tengger
tennet
teochew
tepehuan-northern
tera
ternate
teso-kenyan
tetun-belu
tetun-dili
thai
thai-northern
thai-southern
thami
tharaka
tharu-dangaura
tharu-kathariya
themne
thradhri-kohli
thur
ticuna
tidung-southern
tigak
tigre
tigrinya-eritrea
tigrinya-ethiopia
tigwahanon-manobo
tinonanon-manobo
tira
tiriki
tiruray
tiv
tiwa-northern
tiyaa
tlapaneco-de-tlacoapa
tlicho
toabaita
toba
toba-maskoy
tobelo
tojolabal
tok-pisin
tolaki
toli-gbe-2
toma
tombulu
tomini
tondano
tonga
tonga-malawi
tonga-zambezi
tongan
tonsawang
tonsea
tontemboan
tontemboan-makelai
toposa
toraja
torwali
totonac-coyutla
totonac-papantla
totonaca-sierra
toura
traditional-japanese
trinitario
trique-san-juan-copala
trukese
tsamakko
tshiluba
tsikimba
tsimane
tsimanex
tsimihety
tsishingini
tsogo
tsonga
tsuvadi
tswa
tswana
tu-huzhu
tugen
tula
tulu
tumbuka
tunia
tunjung
tupuri
turka
turkana
turkish
turkmen
tuvin
tuyuca
twi
tyap
tzeltal-bachajon
tzeltal-oxchuc
tzeltal-tenango
tzeltal-tenejapa
tzotzil-chamula
tzutujil-eastern
tzutujil-western
uare
udmurt
uduk
ukaan
ukrainian
ukrainian-sign-language
ukue
umajamnon-manobo
umbundu
uneme-north
uneme-south
urat
urdu
urdu-hoda
urdu-indian
urhobo
urim
uripiv-wala-rano-atchin
urubu-kaapor
usarufa
ushoi
uspanteco
ut-hun
utukwang
uud-danum
uyghur
uyghur-central-asia
uzbek-northern
uzbek-southern
vagla
vai
vaiphei
vajjika
vale
vanuma
varhadi-nagpuri
varli
vasavi
vasavi-kolche
vasui
venda
verre
vidunda
vietnamese
vietnamese-northern
vili
visualvernacular
vitu
vunjo-chagga
vwanji
wa-vo
waama
waata
waddar
wagdi
waghiri
waja
wakatobi
wala
wali
wambon
wamey
wampis
wana-taa
waneci
wanga-luhya
waorani
warao
waray-waray
warji
waropen
wasa
waskia
watakataui
waumeo
waura
wayampi-amapari
wayampi-oiapoque
wayuu
we-northern
welsh
weri-2
western-carib
western-garame
western-lipo
western-poqomchi
wewewa
wichi-lhamtes-guisnay
winye
wolane
wolaytta
wolio
wolof
wondama
worodougou
wumvu
xaasongaxango
xamtanga
xavante
xhosa
xiang
xinulajgsipij
xun
yabem
yaka
yaka-central-african-republic
yaka-d-r-c
yaka-drcongo
yakan
yakha
yakoma
yakpa
yakpa-1
yakut
yala
yalunka
yamba
yamdena
yandang
yanesha
yanomami-ninam
yanomamo
yao
yao-baiku-naogelao
yao-iu-mien
yao-tanzania
yapese
yaqui
yareba
yawa
yemba
yemsa
yerukula
yiddish
yine
yinzebi
yom
yonggom
yoruba
yucuna
yukpa
yungur
yuracare
ywom
zabana
zaiwa
zanaki
zande-drc
zande-south-sudan
zapotec-san-pedro-quiatoni
zapotec-tabaa
zapoteco-de-san-juan-comaltepec
zapoteco-isthmus
zapoteco-mitla
zapoteco-san-juan-guelavia
zapoteco-sierra-de-juarez
zapoteco-southern-rincon
zapoteco-western-pochutla
zapoteco-yalalag
zaramo
zarma
zayse
zhuang-central-hongshuihe
zhuang-dejing
zhuang-guibian
zhuang-liujiang
zhuang-minz
zhuang-nong
zhuang-northern-hongshuihe
zhuang-northern-yongbei
zhuang-qiubei
zhuang-yongnan
zhuang-youjiang
zhuang-zuojiang
zia
zigula
zimba
zing
zinza
zo
zokam-tedim
zoque-francisco-leon
zul
zulu
zuni`

export const PUBLIC_WATCH_LANGUAGE_SLUGS: ReadonlySet<string> = new Set(
  PUBLIC_WATCH_LANGUAGE_SLUG_CORPUS.split("\n"),
)
